/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './number-input.scss';

/* eslint-disable import/no-unresolved, import/default */

import numberInputTemplate from './number-input.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.numberInput', [])
    .directive('tkNumberInput', NumberInput)
    .name;

/*@ngInject*/
function NumberInput($compile, $templateCache) {

    var linker = function (scope, element, attrs, ngModelCtrl) {

        var template = $templateCache.get(numberInputTemplate);
        element.html(template);

        var isMin = false;
        var isMax = false;

        scope.ngModelCtrl = ngModelCtrl;

        ngModelCtrl.$render = function () {
            scope.numVal = constrainedNumber(ngModelCtrl.$viewValue);
            updateMinMaxView();
        };

        scope.numberInputChanged = function() {
            updateValue();
        };

        scope.$watch('min + max + step + allowedStep', () => {
            updateValue();
        });

        scope.placeholderText = function() {
            if (isMin && scope.minText) {
                return scope.minText;
            }
            if (isMax && scope.maxText) {
                return scope.maxText;
            }
            if (scope.titleText) {
                return scope.titleText;
            }
        };

        function updateValue() {
            readMinMaxView();
            scope.numVal = constrainedNumber(scope.numVal);
            ngModelCtrl.$setViewValue(scope.numVal);
            if (scope.onChange) {
                scope.onChange({numVal: scope.numVal});
            }
            updateMinMaxView();
        }

        function readMinMaxView() {
            if (scope.numVal == null) {
                if (isMin && scope.minText) {
                    scope.numVal = scope.min;
                } else if (isMax && scope.maxText) {
                    scope.numVal = scope.max;
                }
            }
        }

        function updateMinMaxView() {
            isMin = scope.numVal == scope.min;
            isMax = scope.numVal == scope.max;
            if (isMin && scope.minText || isMax && scope.maxText) {
                scope.numVal = null;
            }
        }

        function constrainedNumber(num) {
            if (angular.isDefined(num) && num != null) {
                if (num < scope.min) {
                    return scope.min;
                }
                if (num > scope.max) {
                    return scope.max;
                }
                var step = scope.allowedStep ? scope.allowedStep : scope.step;
                return Math.floor(num / step) * step;
            } else {
                if (angular.isDefined(scope.defaultVal) && scope.defaultVal != null) {
                    return scope.defaultVal;
                }
                return scope.min;
            }
        }

        $compile(element.contents())(scope);

    }

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            titleText: '@',
            minText: '@?',
            maxText: '@?',
            min: '=tkMin',
            max: '=tkMax',
            step: '=tkStep',
            defaultVal: '=tkDefaultVal',
            allowedStep: '=?tkAllowedStep',
            disabled: '=ngDisabled',
            onChange: '&?tkNumberChange'
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/number-input.directive.js